import { render, staticRenderFns } from "./shitiLz.vue?vue&type=template&id=2a6aef86&scoped=true"
import script from "./shitiLz.vue?vue&type=script&lang=js"
export * from "./shitiLz.vue?vue&type=script&lang=js"
import style0 from "./shitiLz.vue?vue&type=style&index=0&id=2a6aef86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6aef86",
  null
  
)

export default component.exports